import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';

const readStoredDate = (key) => {
  const raw = localStorage.getItem(key);
  if (!raw) return null;
  const parsed = new Date(raw);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

const initialPeriod = () => ({
  date: readStoredDate('Date') || new Date(),
  startDate: readStoredDate('StartDate') || new Date(),
  endDate: readStoredDate('EndDate') || new Date(),
  biStartDate: readStoredDate('BiStartDate'),
  biEndDate: readStoredDate('BiEndDate'),
  isRange: localStorage.getItem('IsRange') === 'true',
  isBiMonthly: false,
});

const ReportingPeriodContext = createContext(null);

export function ReportingPeriodProvider({ children }) {
  const [period, setPeriod] = useState(initialPeriod);

  const setReportingPeriod = useCallback((next) => {
    setPeriod((prev) => ({ ...prev, ...next }));
  }, []);

  const value = useMemo(
    () => ({
      ...period,
      setReportingPeriod,
    }),
    [period, setReportingPeriod]
  );

  return (
    <ReportingPeriodContext.Provider value={value}>
      {children}
    </ReportingPeriodContext.Provider>
  );
}

export function useReportingPeriod() {
  const ctx = useContext(ReportingPeriodContext);
  if (!ctx) {
    return {
      ...initialPeriod(),
      setReportingPeriod: () => {},
    };
  }
  return ctx;
}
